module.exports = __webpack_public_path__ + "img/menu_mine_on@3x.d05c2453.png";